import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>


      <footer className="site-footer style-1 overlay-primary-light" style={{ backgroundImage: 'url(./assets/images/background/bg4.webp)' }}>
        <div className="footer-head">
          <div className="container">
            <div className="fh-inner">
              <div className="row g-3 align-items-center">
                <div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                  <div className="icon-bx-wraper style-1">
                    <div className="icon-bx bg-secondary">
                      <span className="icon-cell">
                        <i className="feather icon-phone" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-title">हमें कॉल करें</h5>
                      <p><a href="tel:+919165155945" className="text-body">+91 9165155945</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                  <div className="icon-bx-wraper style-1">
                    <div className="icon-bx bg-secondary">
                      <span className="icon-cell">
                        <i className="feather icon-mail" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-title">हमें ईमेल भेजें</h5>
                      <p><a href="mailto:omkarmultispecialityhospital1@gmail.com" className="text-body">omkarmultispecialityhospital1
                        <br />@gmail.com</a></p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                  <div className="icon-bx-wraper style-1">
                    <div className="icon-bx bg-secondary">
                      <span className="icon-cell">
                        <i className="feather icon-clock" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-title">24 घंटे</h5>
                      <p>24/7 आपातकालीन सेवा</p>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                  <div className="icon-bx-wraper style-1">
                    <div className="icon-bx bg-secondary">
                      <span className="icon-cell">
                        <i className="feather icon-map-pin" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <h5 className="dz-title">ऑफ़िस का पता</h5>
                      <a href='https://share.google/DtNHW0PPkiumxpXor' target="_blank" style={{ color: "#031B4E" }}>
                        <p>NH53, near Andhiyarkhop, Arang, Raipur, Chhattisgarh 493441</p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Top */}
        <div className="footer-top" style={{marginTop:"-38px"}}>
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-sm-12 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                <div className="widget widget_about me-2">
                  <div className="footer-logo logo-white">
                    <Link to="/"><img src="./assets/img/logo_1.png" alt style={{ width: "100px", height: "100px" }} /></Link>
                  </div>
                  <p><span className="text-primary"></span>ओंकार मल्टीस्पेशलिटी हॉस्पिटल एक भरोसेमंद हेल्थकेयर संस्थान है, जो सहानुभूति, ईमानदारी और उत्कृष्टता के साथ उच्च-गुणवत्ता वाली चिकित्सा सेवाएँ प्रदान करने के लिए प्रतिबद्ध है।</p>
                </div>
              </div>
              <div className="col-xl-2 col-md-3 col-6 wow fadeInUp" data-wow-delay="0.4s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                <div className="widget widget_services">
                  <h2 className="footer-title">हमारी सेवाएँ </h2>
                  <ul className="list-hover1">
                    <li><Link to="/about-us"><span>हमारे बारे में</span></Link></li>
                    <li><Link to="/orthopedic"><span>हमारी सेवाएँ</span></Link></li>
                    <li><Link to="/gallery"><span>गैलरी</span></Link></li>
                    <li><Link to="/general-surgery"><span>जनरल सर्जरी</span></Link></li>
                    <li><Link to="/dental"><span>डेंटल</span></Link></li>
                    <li><Link to="/faq"><span>अक्सर पूछे जाने वाले सवाल</span></Link></li>

                  </ul>
                </div>
              </div>
              <div className="col-xl-2 col-md-3 col-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.6s', animationName: 'fadeInUp' }}>
                <div className="widget widget_services">
                  <h2 className="footer-title">काम के लिंक</h2>
                  <ul className="list-hover1">
                    <li><Link to="/our-doctor"><span>हमारे डॉक्टर</span></Link></li>
                    <li><Link to="/contact-us"><span>हमसे संपर्क करें</span></Link></li>
                    <li><Link to="/general-medicine"><span>जनरल मेडिसिन</span></Link></li>
                    <li><Link to="/paediatrics"><span>बच्चों का इलाज</span></Link></li>
                    <li><Link to="/blog"><span>हमारा ब्लॉग</span></Link></li>
                    <li><Link to="/contact-us"><span>अपॉइंटमेंट बुक करें</span></Link></li>
                  </ul>
                </div>
              </div>
              {/* <div className="col-xl-2 col-md-3 col-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.8s', animationName: 'fadeInUp' }}>
                <div className="widget widget_services">
                  <h2 className="footer-title">Recent Posts</h2>
                  <ul className="list-hover1">
                    <li><a href="javascript:void(0);"><span>24/7 General Enquiry</span></a></li>
                    <li><a href="javascript:void(0);"><span>100% Expert Doctors</span></a></li>
                    <li><a href="javascript:void(0);"><span>Only Qualified Doctors</span></a></li>
                  </ul>
                </div>
              </div> */}
              <div className="col-xl-5 col-md-3 col-6 wow fadeInUp" data-wow-delay="1.0s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '1s', animationName: 'fadeInUp' }}>
                <div className="widget widget_services">
                  <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=800&height=250&hl=en&q=OMKAR MULTISPECIALITY HOSPITAL NH53, near Andhiyarkhop, Arang, Raipur, Chhattisgarh 493441&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google map embed html</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:250px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:250px;}.gmap_iframe {height:250px!important;}" }} /></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="fb-inner">
              <div className="row">
                <div className="col-lg-6 col-md-12 text-start">
                  <p className="copyright-text"> <span className="current-year"></span> <a style={{ color: "#031B4E" }} href="tel:+918982471422" target="_blank"> 2026 © ओमकार मल्टीस्पेशलिटी हॉस्पिटल | वेब सॉल्यूशन और डिजिटल मार्केटिंग द्वारा डिज़ाइन किया गया।</a> .</p>
                </div>
                <div className="col-lg-6 col-md-12 text-end">
                  <div className="d-flex align-items-center justify-content-center justify-content-md-center justify-content-xl-end">
                    <a href='https://share.google/DtNHW0PPkiumxpXor' target="_blank">
                      <div className="widget-rating1">
                        <img src="./assets/images/google.svg" alt />
                        <ul className="star-list">
                          <li><i className="fa fa-star" /></li>
                          <li><i className="fa fa-star" /></li>
                          <li><i className="fa fa-star" /></li>
                          <li><i className="fa fa-star" /></li>
                          <li><i className="fa fa-star" /></li>
                        </ul>
                        <span className="rating">(4.8)</span>
                        <span className="text">12k+ गूगल पर रेटिंग्स</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Footer Bottom End */}
        <div className="item1">
          <div className="info-widget style-4">
            <div className="widget-media">
              <img src="./assets/images/avatar/small/avatar6.webp" alt />
            </div>
            <div className="widget-content">
              <h6 className="title">Have a Question?</h6>
              <a href="mailto:info@example.com">info@example.com</a>
              <span className="text">John Cane</span>
            </div>
          </div>
        </div>
      </footer>



      {/* <PopUp /> */}
      <WhatsappIcon />



    </>
  )
}

export default Footer